import { defineStore } from 'pinia';

import Coureur from "@/classes/Coureurs/Coureur.class.js";
import List_Courses from "@/classes/Courses/List_Courses.class";
import List_Packs_Courses from "@/classes/Packs_Courses/List_Packs_Courses.class.js";
import UserService from '@/services/user.service';
import { useMainStore } from './mainStore';
export const useInscriptionStore = defineStore('inscription', {
    state: () => ({
        id: null,
        id_module: null,
        id_account: null,
        id_course: null,
        dossard: null,
        nom: null,
        prenom: null,
        sexe: null,
        club: null,
        date_naissance: null,
        id_coureur: null,
        id_commande_inscription: null,
        id_commande: null,
        inscription_sportive: null,
        id_vague_course: null,
        affiche: null,
        paye: null,
        document_recu: null,
        document_valide: null,
        valide: null,
        champs: null,
        coureur: null,
        course: null,
        gia: null,
        donation: null,
        supprime: null,
        transfere: null,
        from_transfert: null,
        commande_inscription: null,
        code_reduction: null,
        refunds: null,
        commande_options: [],
        list_courses: [],
        list_packs_courses: [],
        list_equipe_inscriptions: [],
    }),

    actions: {
        async init() {
            this.$reset();
            const mainStore = useMainStore();
            const id_module = mainStore.module.id;
            this.id_module = id_module;
            this.coureur = new Coureur();
            this.list_courses = new List_Courses(id_module);
            this.list_packs_courses = new List_Packs_Courses(id_module);

        },

        async get() {
            let res = await UserService.getInscription(this.id);
            if (res) { this.set(res); }
            return res;
        },
        async get_alerte_sms_contacts() {

            let res = await UserService.getAlerteSMSContacts(this.id);
            return res;
        },
        async send_bourse_dossard_request(is_vente_equipe) {
            if (is_vente_equipe) {
                let res = await UserService.sendBourseDossardRequestEquipe(this.id, this.id_module, this.refundable_price_equipe);
                return res;
            } else {
                let res = await UserService.sendBourseDossardRequest(this.id, this.id_module, this.refundable_price);
                return res;
            }
        },
        async save_alerte_sms_contacts(alerte_sms_contacts) {
            let res = await UserService.saveAlerteSMSContacts(alerte_sms_contacts);
            return res;
        },
        async get_equipe_inscriptions() {
            let res = await UserService.getEquipeInscriptions(this.id);
            if (res) {
                this.list_equipe_inscriptions = res;
            }

        },
        set(data) {
            for (const [key, value] of Object.entries(data)) {
                if (Object.prototype.hasOwnProperty.call(this, key)) {
                    if (key == "coureur") {
                        this.coureur.set_from_fiche_coureur(value);
                    }
                    else {
                        this[key] = value;
                    }
                }
            }
        },
        listCommandesOptionsTextForEquipeItem(ins) {
            return ins?.commande_options?.map(option => option.quantite + "x " + option.nom).join(', ') || "";
        },
        get_sellable_price(ins) {
            let price = 0;
            price += parseFloat(ins.commande_inscription.prix);
            price += parseFloat(this.get_price_commande_options(ins));
            price += parseFloat(this.get_price_code_reduction(ins));

            return price;
        },
        get_price_commande_options(ins) {
            let price = 0;
            if (ins?.commande_options) {
                for (const option of ins.commande_options) {
                    price += parseFloat(option.prix);
                }
            }
            return price;
        },
        get_price_code_reduction(ins) {
            let price = 0;
            if (ins?.code_reduction && ins.code_reduction.valide == '1' && ins.code_reduction.code_promo_model) {
                price += parseFloat(ins.code_reduction.valeur);
            }
            return price;
        }
    },
    getters: {
        courseName: (state) => {
            return state?.course?.nom || "";
        },
        listCommandesOptionsText: (state) => {
            return state?.commande_options?.map(option => option.quantite + "x " + option.nom).join(', ') || "";
        },
        price_commande_options: (state) => {
            let price = 0;
            if (state?.commande_options) {
                for (const option of state.commande_options) {
                    price += parseFloat(option.prix);
                }
            }
            return price;
        },
        price_code_reduction: (state) => {
            let price = 0;
            if (state?.code_reduction && state.code_reduction.valeur) {
                price += parseFloat(state.code_reduction.valeur);
            }
            return price;
        },
        sellable_price: (state) => {
            let price = 0;
            if (state?.commande_inscription) {
                price += parseFloat(state.commande_inscription.prix);
            }
            price += state.price_commande_options;
            price += state.price_code_reduction;

            return price;
        },
        refundable_price: (state) => {
            return state.sellable_price - 5 > 0 ? state.sellable_price - 5 : 0;
        },
        sellable_price_equipe(state) {
            let price = 0;
            price += this.sellable_price;
            if (state?.list_equipe_inscriptions) {
                for (const inscription of state.list_equipe_inscriptions) {
                    price += parseFloat(this.get_sellable_price(inscription));
                }
            }
            return price;
        },
        refundable_price_equipe(state) {
            const nb_inscriptions = (state?.list_equipe_inscriptions?.length || 0) + 1;
            return this.sellable_price_equipe - 5 * nb_inscriptions > 0 ? this.sellable_price_equipe - 5 * nb_inscriptions : 0;
        },
        frais_vente_equipe() {
            const nb_inscriptions = (this?.list_equipe_inscriptions?.length || 0) + 1;
            return 5 * nb_inscriptions;
        },
        is_inscription_equipe: (state) => {
            return state?.course?.type == "relais" || state?.course?.type == "duo" || state?.course?.type == "equipe";
        }
    }
});


